import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Client from '../utils/network';
import Button from '../components/UI/Button';

export const Overview = () => {
    const [maps, setMaps] = useState<{ name: string, background: string, _id: string }[]>([]);

    const loadMaps = () => {
        Client.request('/api/map').then(async (res) => {
            const body = await res.json() as { name: string, background: string, _id: string }[];
            setMaps(body);
            return;
        }).catch(err => {
            // eslint-disable-next-line no-console
            console.error(err);
        });
    };

    useEffect(() => {
        loadMaps();
    }, []);

    const onDelete = (id: string) => {
        Client.request(`/api/map/${id}`, {
            method: 'DELETE',
        }).finally(() => {
            loadMaps();
        }).catch(() => {
            // do nothing
        });
    };

    return (
        <div className='p-4'>
            <Link
                className={'block w-fit pl-3 pr-3 p-2 rounded-md bg-mid-blue hover:bg-gray-500 mb-3'}
                to='/main/create'
            >
                Create
            </Link>
            <div className='flex flex-wrap overflow-auto pretty-scroll gap-x-8 gap-y-8 rounded-md'>
                {maps.map((map) => (
                    <Link className='block w-fit' key={map._id} to={`/main/view/${map._id}`}>
                        <div className='p-4 bg-mid-blue rounded-md'>
                            <div className='mb-2 font-semibold'>{map.name}</div>
                            <img
                                className="rounded-lg"
                                src={`${Client.getBaseUrl()}/api/image/${map.background}/thumbnail`}
                            />

                            <Button className="mt-3" flipped onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                onDelete(map._id);

                            }}>
                                Delete
                            </Button>
                        </div>
                    </Link>
                ))}
            </div>

        </div>
    );
};

export default Overview;
